/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiSanctionType {
    SANCTION = 'SANCTION',
    PEP = 'PEP',
    ADVERSE_MEDIA = 'ADVERSE_MEDIA',
    ADVERSE_MEDIA_ENTITY = 'ADVERSE_MEDIA_ENTITY',
    CUSTOM_SCREENING_LIST = 'CUSTOM_SCREENING_LIST'
}


export function instanceOfApiSanctionType(value: any): boolean {
    for (const key in ApiSanctionType) {
        if (Object.prototype.hasOwnProperty.call(ApiSanctionType, key)) {
            if (ApiSanctionType[key as keyof typeof ApiSanctionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiSanctionTypeFromJSON(json: any): ApiSanctionType {
    return ApiSanctionTypeFromJSONTyped(json, false);
}

export function ApiSanctionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionType {
    return json as ApiSanctionType;
}

export function ApiSanctionTypeToJSON(value?: ApiSanctionType | null): any {
    return value as any;
}

export function ApiSanctionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiSanctionType {
    return value as ApiSanctionType;
}

